import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { REGISTRATION_STEP } from 'constants/registrationStep';
import { useMenuDetailStore } from '../../hooks';
import { MenuEditResultModalView } from './MenuEditResultModalView';
import { MenuEditConfirmModalView } from './MenuEditConfirmModalView';
import { MenuEditInputModalView } from './MenuEditInputModalView';

type Props = ReturnType<typeof useMenuDetailStore>;

export const MenuModalView: FC<Props> = ({
  isOpenModal,
  currentModalStep,
  onCloseModal,
  onCloseModalWhenCompleted,
  form,
  values,
  canDelete,
  crawlers,
  menuCrawlers,
  onConfirm,
  onGoBack,
  onSubmit,
  onOpenModalDelete,
  onAddCrawler,
  onDeleteCrawler,
  onSortCrawler,
  menuCustomers,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <MenuEditInputModalView
        {...form}
        values={values}
        canDelete={canDelete}
        crawlers={crawlers}
        menuCrawlers={menuCrawlers}
        handleConfirm={onConfirm}
        handleDeleteConfirm={onOpenModalDelete}
        handleAddCrawler={onAddCrawler}
        handleDeleteCrawler={onDeleteCrawler}
        handleSortCrawler={onSortCrawler}
        menuCustomers={menuCustomers}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <MenuEditConfirmModalView
        values={values}
        crawlers={crawlers}
        menuCrawlers={menuCrawlers}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
        handleAddCrawler={onAddCrawler}
        handleDeleteCrawler={onDeleteCrawler}
        handleSortCrawler={onSortCrawler}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <MenuEditResultModalView
        values={values}
        handleClose={onCloseModalWhenCompleted}
      />
    )}
  </Modal>
);
